import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RightsAccess } from '../../helper';
import { useComponent } from '../../../Pages/UserSetting/UsersLibrary/UserRights';
import MenuItem from '../MenuItem';
import {
  ProductIdentityIcon,
  LibraryGroupIcon,
  CareLibraryIcon,
  ColourLibraryIcon,
  CostingLibraryIcon,
  CustomModulesIcon,
  DPPLibraryIcon,
  FreightDutyLibraryIcon,
  MeasurementsIcon,
  PurchaseOrderLibraryIcon,
  SpecTemplateLibraryIcon,
  TestingLibraryIcon
} from '../../../bombiix-icon';

function LibraryTemplateURL({ isMobileMenu }) {
  const history = useHistory();
  const pathName = history?.location?.pathname;
  const reducer = useSelector((reducerstate) => reducerstate);
  const {
    Users: { logInRights, moduleAccess },
  } = reducer;
  const [userRights, setUserRights] = useState({});
  const { frieghtRight, customModuleRight, productCostingRight, purchaseOrderRight, TestingRight, DPPRight } = RightsAccess();
  const { createConditionalComponent } = useComponent();
  const BomRightsAccess = createConditionalComponent(userRights, 'libraries', 'bom');
  const ColourRightsAccess = createConditionalComponent(userRights, 'libraries', 'colours');
  const PomGradingRightsAccess = createConditionalComponent(userRights, 'libraries', 'pomGrading');
  const SpecRightsAccess = createConditionalComponent(userRights, 'libraries', 'spec');
  const CareRightsAccess = createConditionalComponent(userRights, 'libraries', 'care');
  const CustomRightsAccess = createConditionalComponent(userRights, 'libraries', 'customModule');
  const TestingRightsAccess = createConditionalComponent(userRights, 'libraries', 'testing');
  const PoTemplateRightsAccess = createConditionalComponent(userRights, 'libraries', 'poTemplate');
  const CostingTemplateRightsAccess = createConditionalComponent(userRights, 'libraries', 'costingTemplate');
  const RetailIdentifierRightsAccess = createConditionalComponent(userRights, 'libraries', 'retailIdentifier');
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  return (
    <ul>
      <ColourRightsAccess>
        <MenuItem
          activeClassList={['/libraries/colour-library', '/colour-groups']}
          pathName={pathName}
          linkTo="/libraries/colour-library"
          IconComponent={ColourLibraryIcon}
          titleKey="SUB_HEADER.COLOURS_ARTWORK"
          isMobileMenu={isMobileMenu}
        />
      </ColourRightsAccess>

      <BomRightsAccess>
        <MenuItem
          activeClassList={['/libraries/bom-type']}
          pathName={pathName}
          linkTo="/libraries/bom-type"
          IconComponent={LibraryGroupIcon}
          titleKey="SUB_HEADER.BOM"
          isMobileMenu={isMobileMenu}
        />
      </BomRightsAccess>

      <PomGradingRightsAccess>
        <MenuItem
          activeClassList={['/libraries/point-of-measures', '/pom-groups', '/gradings']}
          pathName={pathName}
          linkTo="/libraries/point-of-measures"
          IconComponent={MeasurementsIcon}
          titleKey="SUB_HEADER.POM_GRADINGS"
          isMobileMenu={isMobileMenu}
        />
      </PomGradingRightsAccess>
      <SpecRightsAccess>
        <MenuItem
          activeClassList={['/libraries/spec-template']}
          pathName={pathName}
          linkTo="/libraries/spec-template"
          IconComponent={SpecTemplateLibraryIcon}
          titleKey="SUB_HEADER.SPEC_TEMPLATES"
          isMobileMenu={isMobileMenu}
        />
      </SpecRightsAccess>

      <CareRightsAccess>
        <MenuItem
          activeClassList={['/libraries/care-user-instruction', '/care-group']}
          pathName={pathName}
          linkTo="/libraries/care-user-instruction"
          IconComponent={CareLibraryIcon}
          titleKey="SUB_HEADER.CARE_USER_LABELS"
          isMobileMenu={isMobileMenu}
        />
      </CareRightsAccess>

      <CustomRightsAccess>
        {customModuleRight && (
          <MenuItem
            activeClassList={['/libraries/custom-module/library', 'custom-module/group']}
            pathName={pathName}
            linkTo="/libraries/custom-module/library"
            IconComponent={CustomModulesIcon}
            titleKey="SUB_HEADER.ADDITIONAL_INFORMATION"
            isMobileMenu={isMobileMenu}
          />
        )}
      </CustomRightsAccess>

      {DPPRight && moduleAccess?.dppAccess && (
        <MenuItem
          activeClassList={['/libraries/dpp']}
          pathName={pathName}
          linkTo="/libraries/dpp"
          IconComponent={DPPLibraryIcon}
          titleKey="SUB_HEADER.DPP"
          isMobileMenu={isMobileMenu}
        />
      )}
      <RetailIdentifierRightsAccess>
        <MenuItem
          activeClassList={['/libraries/retail-identifier']}
          pathName={pathName}
          linkTo="/libraries/retail-identifier"
          IconComponent={ProductIdentityIcon}
          titleKey="SUB_HEADER.RETAIL_IDENTIFIER"
          isMobileMenu={isMobileMenu}
        />
      </RetailIdentifierRightsAccess>
      <TestingRightsAccess>
        {TestingRight && (
          <MenuItem
            activeClassList={['/libraries/testing']}
            pathName={pathName}
            linkTo="/libraries/testing"
            IconComponent={TestingLibraryIcon}
            titleKey="SUB_HEADER.TESTING"
            isMobileMenu={isMobileMenu}
          />
        )}
      </TestingRightsAccess>
      {purchaseOrderRight && (
        <PoTemplateRightsAccess>
          <MenuItem
            activeClassList={['/libraries/purchase-order-template']}
            pathName={pathName}
            linkTo="/libraries/purchase-order-template"
            IconComponent={PurchaseOrderLibraryIcon}
            titleKey="SUB_HEADER.PO_TEMPLATES"
            isMobileMenu={isMobileMenu}
          />
        </PoTemplateRightsAccess>
      )}
      {productCostingRight && (
        <CostingTemplateRightsAccess>
          <MenuItem
            activeClassList={['/libraries/costing-template']}
            pathName={pathName}
            linkTo="/libraries/costing-template"
            IconComponent={CostingLibraryIcon}
            titleKey="SUB_HEADER.COSTING_TEMPLATE"
            isMobileMenu={isMobileMenu}
          />
        </CostingTemplateRightsAccess>
      )}
      {frieghtRight && (
        <MenuItem
          activeClassList={['/libraries/freight-duty', '/libraries/freight', '/libraries/duty']}
          pathName={pathName}
          linkTo="/libraries/freight-duty?tab=freight"
          IconComponent={FreightDutyLibraryIcon}
          titleKey="SUB_HEADER.FREIGHT_AND_DUTY"
          isMobileMenu={isMobileMenu}
        />
      )}
      <MenuItem
        activeClassList={['/libraries/asset-library']}
        pathName={pathName}
        linkTo="/libraries/asset-library"
        iconClass="icon-DAM-1"
        titleKey="ASSET_LIBRARY.SYSTEM_MASTER_TAB"
        isMobileMenu={isMobileMenu}
      />
    </ul>
  );
}

export default LibraryTemplateURL;
